import React from "react"
import Banner from "shared/components/Banner"
import ModernButton from "shared/components/Button/ModernButton"
import Typograph from "components/Typograph"

import styles from "../styles.css"

const BannerClubAlgar = () => (
  <Banner
    classNames={styles.banner}
    gradientColor="sandstorm"
    iconName="LogoClubeAlgar"
  >
    <Typograph
      htmlTag="h2"
      size="extra_large"
      color="outer_space"
      weight="semi_bold"
    >
      Quanto mais Algar, mais <br /> vantagens e prêmios pra você.
    </Typograph>
    <Typograph
      htmlTag="h3"
      size="large"
      color="outer_space"
      weight="regular"
      classNames={styles.bannerSubTitle}
    >
      Conheça o seu novo clube de benefícios.
    </Typograph>
    <ModernButton
      shape="full"
      size="medium"
      buttonColor="deep_sea_green"
      text="Saber mais"
      textColor="white"
      textSize="small"
      withBorderRadius
      onClick={() => {
        window.open("http://www.algar.com.br/clubedebeneficios", "_blank")
      }}
    />
  </Banner>
)

export default BannerClubAlgar



// WEBPACK FOOTER //
// ./src/scenes/AlgarForever/components/BannerClubAlgar.js